export const environment = {
  production: false,
  apiAuthUrl: 'https://dev-auth-eu-south-2.service.3ddvapis.com',
  apiVenuesUrl: 'https://dev-venues-eu-south-2.service.3ddvapis.com',

  //apiAuthUrl: 'https://tmp-auth-eu-south-2.service.3ddvapis.com',
  //apiVenuesUrl: 'https://tmp-venues-eu-south-2.service.3ddvapis.com',
  sitesBuilder: {
    api: 'https://dev-sitesbuilder-eu-south-2.service.3ddvapis.com',
    app_url: 'https://dev-venues.3ddigitalvenue.com/',
    staticrsc_cdn: 'https://vw-dev-sitesbuilder.eu-west-1.staticresources.3ddvfactory.com/sitesbuilder/',
    // staticrsc_s3:
    //   'https://s3.eu-west-1.amazonaws.com/vw-dev-sitesbuilder.eu-west-1.staticresources.3ddvfactory.com/sitesbuilder/',
  },
  editor2dmaps: {
    api: ' https://dev-2dmapseditor-eu-south-2.service.3ddvapis.com/api/v1',
    staticrsc_cdn: 'https://vw-dev-mapeditor-staticrsc.3ddvfactory.com',
  },
  availabilityManager: {
    api: 'dev-private-contentdistribution-eu-south-2.service.3ddvapis.com',
    //api: 'tmp-private-contentdistribution-eu-south-2.service.3ddvapis.com',
    apiLocal: 'http://localhost:3333',
    bucket: 'w3ddv-minisites',
  },
  contentdistribution: {
    private: {
      url: 'https://dev-private-contentdistribution-eu-south-2.service.3ddvapis.com',
      tmpdata: {
        maps: [
          {
            id: 5,
            name: 'blockmap2dhd',
            created_at: '2024-05-28 10:50:18',
            updated_at: '2024-05-28 10:50:18',
            type: '2DHD',
          },
          {
            id: 6,
            name: 'blockmap2d',
            created_at: '2024-05-28 10:50:18',
            updated_at: '2024-05-28 10:50:18',
            type: '2D',
          },
          {
            id: 7,
            name: 'main',
            created_at: '2024-05-28 10:50:18',
            updated_at: '2024-05-28 10:50:18',
            type: null,
          },
          {
            id: 8,
            name: 'blockmap',
            created_at: '2024-05-28 10:50:18',
            updated_at: '2024-05-28 10:50:18',
            type: null,
          },
        ],
      },
    },
    public: {
      url: {
        global: 'https://contentdistribution.3ddvapis.com',
        euwest1: 'https://contentdistribution-eu-west-1.3ddvapis.com',
        euwest3: 'https://contentdistribution-eu-west-3.3ddvapis.com',
        uswest1: 'https://contentdistribution-us-west-1.3ddvapis.com',
        uswest2: 'https://contentdistribution-us-west-2.3ddvapis.com',
        apnortheast2: 'https://contentdistribution-ap-northeast-2.3ddvapis.com',
      },
    },
  },
  apiContentUploaderUrl: 'https://dev-contentuploader-eu-south-2.service.3ddvapis.com',
  catalog: {
    cdnDomain: 'https://vw-catalog.eu-west-1.staticresources.3ddvfactory.com',
    accountName: 'core',
    bucketName: 'vw-catalog.eu-west-1.staticresources.3ddvfactory.com',
    cdnId: 'E1HJZ22RPCX3FS',
  },
  apiSeatingChartViewer: {
    api: 'https://dev-seatingchartviewer-eu-south-2.service.3ddvapis.com/api/v1',
    aws: {
      bucketName: 'vw-dev-scv.eu-west-1.staticresources.3ddvfactory.com',
      accountName: 'core',
      cdnId: 'E352IWRF39NJG1',
      cdnDomain: 'https://vw-dev-seatingchartviewer.staticresources.3ddvfactory.com',
    },
    public: 'https://dev-seatingchartviewer-eu-south-2.service.3ddvapis.com/public/v1',
    publicV2: 'https://dev-seatingchartviewer-eu-south-2.service.3ddvapis.com/public/v2',
  },
  mlb: {
    cdnDomain: 'https://dev-mlb.venues.3ddigitalvenue.com',
    s3Domain: 'https://s3.eu-west-1.amazonaws.com/dev-vw-mlb-sites.3ddigitalvenue.com',
    accountName: 'core',
    bucketName: 'dev-vw-mlb-sites.3ddigitalvenue.com',
    cdnId: 'E1KOQSNP4CS95P',
  },
  googleplaces: {
    apikey: 'AIzaSyD9BnoUOkR-Pqr8ctFbfqv23415xYu-69U',
    apiUrl: 'https://maps.googleapis.com',
  },
  oidc: {
    clientId: '45eef040-db0f-013d-aab9-2f876520af4a39188',
    issuer: 'https://3ddigitalvenue.onelogin.com/oidc/2',
  },
  amenityManagementSystem: {
    url: 'https://dev-ams-eu-south-2.service.3ddvapis.com/private/v1',
  },
  billing: {
    url: 'https://dev-billing-eu-south-2.service.3ddvapis.com',
    supportEmail: 'support@3ddigitalvenue.com',
  },
  sentry: {
    // TODO: set the per-environment DSN. Empty => the SDK is not initialized and nothing is sent.
    dsn: 'https://2348070a5fd729d7a25f492deaa13a1c@o285725.ingest.us.sentry.io/4511738436321280',
    environment: 'development',
  }
};
